import { useId, useState } from "react";

export function PasswordFieldWithToggle(props: {
  label: string;
  autoComplete: string;
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  placeholder?: string;
  onEnter?: () => void;
}) {
  const [visible, setVisible] = useState(false);
  const baseId = useId();
  const inputId = `${baseId}-pw`;

  return (
    <div className="block">
      <label htmlFor={inputId} className="text-xs font-medium text-slate-700 dark:text-slate-300">
        {props.label}
      </label>
      <div className="relative mt-1">
        <input
          id={inputId}
          type={visible ? "text" : "password"}
          autoComplete={props.autoComplete}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") props.onEnter?.();
          }}
          placeholder={props.placeholder}
          disabled={props.disabled}
          className="w-full rounded-lg border border-slate-200 bg-white py-2 pl-3 pr-11 text-sm text-slate-900 dark:border-slate-600 dark:bg-slate-950 dark:text-slate-100"
        />
        <button
          type="button"
          tabIndex={-1}
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          disabled={props.disabled}
          onClick={() => setVisible((v) => !v)}
          className="absolute right-1 top-1/2 -translate-y-1/2 rounded-md px-2 py-1 text-xs font-medium text-slate-600 hover:bg-slate-100 disabled:opacity-50 dark:text-slate-400 dark:hover:bg-slate-800"
        >
          {visible ? "Hide" : "Show"}
        </button>
      </div>
    </div>
  );
}
